import { createAsyncThunk } from '@reduxjs/toolkit'
import {
  Adjustment,
  createAdjustment as createAdjustmentApi,
  CreateAdjustmentRequest,
  ProcedureAdjustment,
} from '@services/api/billing/adjustment.api'

export interface CreateAdjustmentResult {
  adjustment: Adjustment
  procedureAdjustments: ProcedureAdjustment[]
}

export const createAdjustment = createAsyncThunk<
  CreateAdjustmentResult,
  CreateAdjustmentRequest,
  { rejectValue: string }
>('api/adjustment/create', async (payload, { rejectWithValue }) => {
  try {
    const response = await createAdjustmentApi(payload)

    if (response.statusCode < 200 || response.statusCode >= 300) {
      return rejectWithValue(response.message || 'Failed to create adjustment')
    }

    return {
      adjustment: response.data.adjustment,
      procedureAdjustments: response.data.procedure_adjustments,
    }
  } catch (error: unknown) {
    const message =
      error instanceof Error ? error.message : 'Failed to create adjustment'
    return rejectWithValue(message)
  }
})
